import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../api/client";

interface IngestRun {
  run_id: string;
  source: "zillow" | "realtor";
  started_at: string;
  finished_at: string | null;
  count_new: number;
  count_updated: number;
  count_errors: number;
  error_summary: string | null;
}

export default function Dashboard() {
  return (
    <>
      <h1 style={{ marginTop: 0 }}>Insights</h1>
      <RecentRunsCard source="zillow" />
      <RecentRunsCard source="realtor" />
    </>
  );
}

function RecentRunsCard({ source }: { source: "zillow" | "realtor" }) {
  const q = useQuery<{ runs: IngestRun[] }>({
    queryKey: ["ingest-runs", source],
    queryFn: () => apiGet(`/api/ingest-runs?source=${source}`),
  });
  return (
    <div className="panel">
      <h3 style={{ marginTop: 0 }}>Recent {source} sweeps</h3>
      {q.isLoading && <p className="muted">Loading…</p>}
      {q.error && <p className="tag-error">Failed to load.</p>}
      {q.data && (
        <table>
          <thead>
            <tr>
              <th>Started</th>
              <th>New</th>
              <th>Updated</th>
              <th>Errors</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            {q.data.runs.length === 0 && (
              <tr>
                <td colSpan={5} className="muted">
                  No runs yet.
                </td>
              </tr>
            )}
            {q.data.runs.map((r) => (
              <tr key={r.run_id}>
                <td className="muted">{fmtTime(r.started_at)}</td>
                <td>{r.count_new}</td>
                <td>{r.count_updated}</td>
                <td className={r.count_errors > 0 ? "tag-error" : ""}>{r.count_errors}</td>
                <td className="muted" style={{ maxWidth: 480, fontSize: 12 }}>
                  {r.error_summary ?? "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

function fmtTime(iso: string): string {
  try {
    const d = new Date(iso);
    return d.toLocaleString();
  } catch {
    return iso;
  }
}
